import styled from 'styled-components';
import { DefaultParagraphLargeFactory, DefaultParagraphSmallFactory, DefaultTitleMediumFactory } from '../../../../../../components/Habitacional/core/Typograph/Typograph.Style';

export const ContainerCompleteFormDFI = styled.div(() => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap:"40px",
    flex: "1 0 0",
}))

export const ContainerTextCompleteFormDFI = styled.div(() => ({
    display: "flex",
    alignSelf: "stretch",
    marginTop: "12px"
}))

export const ContainerDataCompleteFormDFI = styled.div(() => ({
    display: "flex",
    gap: "16px",
    alignSelf: "stretch",
    flexDirection: "column",
}))

export const ContentNumberCompleteFormDFI = styled.div(() => ({
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    gap: "24px",
    alignSelf: "stretch",
}))

export const ContentDataCompleteFormDFI = styled.div(() => ({
    display: "flex",
    padding: "16px 0px",
    justifyContent: "center",
    alignItems: "center",
    gap: "12px",
    alignSelf: "stretch",
    maxWidth: "746px",
    borderBottom: "1px solid #D1DBE3"
}))

export const DataCompleteFormDFI = styled.div(() => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: "4px",
    flex: "1 0 0",
}))

export const TitleDataCompleteFormDFI = styled.p(({theme}) => ({
    ...DefaultParagraphSmallFactory({theme}),
    color: theme.color.neutral["03"]
}))

export const DescriptionDataCompleteFormDFI = styled.p(({theme}) => ({
    ...DefaultParagraphLargeFactory({theme})
}))

export const DescriptionCompleteFormDFI = styled.h3(({theme}) => ({
    ...DefaultParagraphLargeFactory({theme})
}))

export const TitleNumberCompleteFormDFI = styled.h4(({theme}) => ({
    ...DefaultTitleMediumFactory({theme})
}))

export const NumberCompleteFormDFI = styled.h4(({theme}) => ({
    fontSize: '28px',
    lineHeight: '150%',
    fontWeight: 500,
    marginBotton: '12px',
    color: theme.color.brandSecondary.medium,
    
    [theme.breakpoint.lg()]: {
        fontSize: '40px'
    }
}))